import React, { Component } from 'react';

import { postJson } from '../../helpers/RequestsHelper'

class GuestBookComment extends Component {

    state = {
        notes: "",
        email: "",
        name: "",
        id: 3,
        localId: ""
    }

    constructor() {
        super()
        this.onSubmit = this.onSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
    }

    componentDidMount() {
        let localId = localStorage.getItem("localId");
        if (!localId) {
            const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
            localId = uint32.toString(16)
            localStorage.setItem("localId", localId);
        }
        this.setState({ localId })
    }

    onSubmit = async (e) => {
        let body = this.state

        const cognitoUser = window.userPool.getCurrentUser()

        if (cognitoUser) {
            //This is done for open surveys
            body.userId = cognitoUser.username
        }

        await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/survey/result", body)

        this.props.onCompleted()

        this.setState({ completed: true })
    }

    onChange = (state) => {
        state.completed = false
        this.setState(state, () => this.props.onChange(this.state))
    }

    validateEmail(email) {
        if (!email) {
            return true
        }
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    render() {
        return (
            <div>
                <div>
                    Email
                    <br />
                    { this.validateEmail(this.state.email) ? "" : <small id="errorMessage" className="text-danger">Please enter a valid email address</small>}
                    <input className="form-control w-600"
                        type="email"
                        name="email"
                        autoComplete="email"
                        id="email"
                        required="true"
                        onChange={(e) => this.onChange({ email: e.target.value })} />
                    <br />
                    Name
                    <br />
                    <input className="form-control w-600"
                        type="text"
                        name="name"
                        autoComplete="name"
                        id="name"
                        required="true"
                        onChange={(e) => this.onChange({ name: e.target.value })} />
                    <br />
                </div>
                <br />
                Please leave your comment
                <br />
                <textarea className="form-control w-800" onChange={(e) => this.onChange({ notes: e.target.value })}></textarea>
                <br />

                {this.state.completed
                    ? "Thanks!"
                    : <button className="submit-btn" onClick={this.onSubmit} disabled={!this.state.email || !this.state.name}>Submit</button>
                }
            </div>
        )
    }
}

export default GuestBookComment;